import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SummaryPage from "./SummaryPage";
import StepsBar from "../../widgets/StepsBar";
import { getContentHeight } from "../../../../../utils/textUtils";
import { updateSection } from "../../../assignmentSlice";

// ECHO 시안 01: 시작 버튼 페이지 없이 진입 즉시 핵심 정리를 보여준다.
// 하단 "학습 시작하기 →" 버튼이 기존 우측 화살표(완료 처리)를 대체한다.
const KeyPointsPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section, paragraph } = useSelector((state) => state.assignment);

  const [isMobile, setIsMobile] = useState(Math.min(window.innerWidth, window.screen.width) <= 768);
  useEffect(() => {
    const onResize = () => setIsMobile(Math.min(window.innerWidth, window.screen.width) <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleComplete = () => {
    if (!isPreview && !isReview) {
      dispatch(
        updateSection({ sectionId: section.id, data: { is_finished: true } })
      );
    }
    alert("학습이 완료되었습니다.");
    setCurrentStep(2);
  };

  return (
    <div
      style={{
        backgroundColor: "#FFF",
        height: getContentHeight(isMobile),
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ECHO 시안 01 — 지문분석 단계 표시줄 */}
      <StepsBar />
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          padding: isMobile ? "14px 12px 24px" : "24px 20px 32px",
        }}
      >
        <SummaryPage
          section={section}
          paragraph={paragraph}
          isMobile={isMobile}
          onComplete={handleComplete}
        />
      </div>
    </div>
  );
};

export default KeyPointsPage;
